import {
  ConditionId,
  UserId,
  Condition as ConditionBase,
  ScoringSystemsFirstResult,
  Perspective,
  AssigmentSource,
  Pathology,
  BodySite,
  BodySiteId,
  PathologyId
} from '@legit-health/ui';

export class Condition extends ConditionBase {
  constructor(
    readonly id: ConditionId,
    readonly bodySite: BodySite,
    readonly pathology: Pathology,
    readonly practitioner: UserId,
    readonly frequency: number,
    readonly isTracked: boolean,
    readonly assigmentSource: AssigmentSource,
    readonly firstImage: string | null,
    readonly firstImageThumbnail: string | null,
    readonly createdAt: string,
    readonly firstImageOfPerspective: Record<Perspective, string>,
    readonly scoringSystemsFirstResults: ScoringSystemsFirstResult[],
    readonly canBetracked: boolean
  ) {
    super(
      id,
      bodySite,
      pathology,
      practitioner,
      frequency,
      isTracked,
      assigmentSource,
      firstImage,
      firstImageThumbnail,
      createdAt,
      firstImageOfPerspective,
      canBetracked
    );
  }
}

export interface ConditionApiResponse {
  id: ConditionId;
  isTracked: boolean;
  firstImage: string | null;
  firstImageThumbnail: string | null;
  frequency: number;
  assigmentSource: AssigmentSource;
  scoringSystemsFirstResults: ScoringSystemsFirstResult[];
  createdAt: string;
  bodySite: BodySiteId;
  pathology: PathologyId;
  practitioner: UserId;
  firstImageOfPerspective: Record<Perspective, string>;
  canBeTracked: boolean;
}
